import { IMG } from "../../data/site";
import { Reveal, RevealImage, SectionMark } from "./Reveal";

export const Statement = () => (
    <section
        data-testid="statement-section"
        className="relative px-5 py-28 md:px-10 md:py-44"
    >
        <div className="mx-auto grid max-w-[1400px] items-center gap-14 md:grid-cols-12 md:gap-10">
            <div className="md:col-span-7">
                <Reveal>
                    <SectionMark>( 02 — Ramljak )</SectionMark>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-8 font-display text-4xl font-light leading-[1.04] tracking-tight text-bone sm:text-5xl lg:text-[4.6rem]">
                        NIJE SAMO
                        <br />
                        ČIST AUTOMOBIL.
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-8 font-display text-xl font-light italic leading-snug text-bronze sm:text-2xl lg:text-3xl">
                        To je onaj osjećaj kada ga ponovno pogledate.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <p className="mt-10 max-w-md text-sm leading-relaxed text-silver md:text-base">
                        Ramljak Auto Detailing Centar posvećen je detaljnoj
                        njezi vozila, od dubinskog čišćenja interijera do
                        obrade vanjskih površina.
                    </p>
                </Reveal>
            </div>
            <div className="md:col-span-5">
                <RevealImage
                    src={IMG.statement}
                    alt="Crno vozilo u pokretu nakon detailinga"
                    className="aspect-[3/4] md:aspect-[4/5]"
                />
            </div>
        </div>
    </section>
);
